const project_manage = [{
    path: 'project-manage/version/list',
    meta: {
      name: "版本管理"
    }
  },
  {
    path: 'project-manage/report-manage/list',
    meta: {
      name: "项目汇报"
    }
  },
  {
    path: 'project-manage/overtime-manage/list',
    meta: {
      name: "加班汇总"
    }
  },
  {
    path: 'project-manage/projectMember-manage/list',
    meta: {
      name: "项目成员管理"
    }
  },
  {
    path: 'project-manage/projectMember-manage/roleAuthority',
    meta: {
      name: "配置角色权限"
    }
  },
  {
    path: 'project-manage/projectMember-manage/projectDataBoard',
    meta: {
      name: "项目数据看板"
    }
  },
  // {path: 'project-manage/demand-manage/demandDetail', meta: { name: "需求详情"}}
  // {path: 'project-manage/change-manage/check-list', meta: { name: "查看涉及变更需求"}}
  {
    path: 'project-manage/projectContact',
    meta: {
      name: "项目联系人"
    }
  },
  {
    path: 'project-manage/projectManagerPannel',
    meta: {
      name: "全部项目"
    }
  },
  {
    path: 'project-manage/new-start/NewStart',
    meta: {
      name: "新启动"
    }
  },
  {
    path: 'project-manage/report-manage/weekly',
    meta: {
      name: "提交周报"
    }
  },
  {
    name: 'newWeekly',
    path: 'project-manage/report-manage/newWeekly',
    meta: {
      name: "提交周报1"
    }
  }
]

export default project_manage



// WEBPACK FOOTER //
// ./src/router/mapping/project-manage.js